import * as React from 'react';
const EmoglobinaBassaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M116.34 123.5a22.07 22.07 0 0 0 7.34-16.47c0-12.23-9.92-22.15-22.15-22.15s-22.15 9.92-22.15 22.15 9.55 21.78 21.47 22.14"
      className="prefix__cls-2"
    />
    <path
      d="M97.13 122.68c-2.72-.75-5.15-2.22-7.09-4.15-2.94-2.94-4.76-7-4.76-11.49 0-8.98 7.27-16.25 16.25-16.25 4.49 0 8.55 1.82 11.49 4.76s4.76 7 4.76 11.49-1.72 8.34-4.52 11.25"
      className="prefix__cls-1"
    />
    <path
      d="M108.72 86.08c-15.13-5.8-17.8-8.13-27.23-20.26-2.03-2.61-5.06-4.3-8.39-4.67-3.32-.37-6.66.61-9.23 2.72-.6.49-1.13 1.02-1.56 1.53-2.93 3.53-4.1 8.17-3.18 12.64 2.61 13.61 8.1 27.57 27.34 45.23"
      className="prefix__cls-2"
    />
    <path
      d="M139.36 121.98c-3.21-2.92-9.58-1.87-14.23 2.35-4.64 4.22-5.8 10.01-2.59 12.93s9.58 1.87 14.23-2.35c4.64-4.22 5.8-10.01 2.59-12.93"
      className="prefix__cls-1"
    />
    <path
      d="M135.61 126.11c.17.44-.28 2.59-2.59 4.68-2.07 1.89-4.29 2.56-5.68 2.56h0M98.54 118.69c2.55-2.32 7.61-1.49 11.3 1.87 3.69 3.35 4.61 7.95 2.05 10.27-2.55 2.32-7.61 1.49-11.3-1.87-3.69-3.35-4.61-7.95-2.05-10.27M104.67 112.03c-1.63-1.62-1.06-4.84 1.28-7.19s5.56-2.95 7.2-1.33 1.06 4.84-1.28 7.19-5.56 2.95-7.2 1.33M96.45 111.36c2.4-.62 3.98-3.71 3.52-6.91-.46-3.21-2.78-5.3-5.18-4.69-2.41.61-3.98 3.71-3.52 6.91s2.78 5.3 5.18 4.69"
      className="prefix__cls-1"
    />
  </svg>
);
export default EmoglobinaBassaIcon;
